import { Flex, Typography } from '@ghq-abi/design-system-v2';

import { Avatar } from '../Avatar';

type PersonalProfileProps = {
  name?: string;
  firstName?: string;
  lastName?: string;
  jobTitle?: string;
  globalId?: string;
  className?: string;
  customHeadingWidth?: string;
};

export function PersonalProfile({
  name = '',
  firstName = '',
  lastName = '',
  jobTitle = '',
  globalId = '',
  className = '',
  customHeadingWidth
}: PersonalProfileProps) {
  return (
    <Flex align="center" justify="center" className={`gap-2 ${className}`}>
      <Avatar
        globalId={globalId ?? ''}
        name={name || `${firstName} ${lastName}`}
      />
      <Flex direction="column" justify="center" className="flex-grow">
        <Typography
          variant="body-sm-medium"
          title={name}
          className="leading-normal text-gray-700 truncate"
          style={{ width: customHeadingWidth || 'auto' }}>
          {firstName} {lastName}
        </Typography>
        <Typography
          variant="metadata-xs-regular"
          title={jobTitle}
          className="truncate max-h-9">
          {jobTitle}
        </Typography>
      </Flex>
    </Flex>
  );
}
